/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ItemItemTranslationParam from './ItemItemTranslationParam';

/**
 * The ItemCreateItemParam model module.
 * @module model/ItemCreateItemParam
 * @version 1.0
 */
class ItemCreateItemParam {
    /**
     * Constructs a new <code>ItemCreateItemParam</code>.
     * @alias module:model/ItemCreateItemParam
     */
    constructor() { 
        
        ItemCreateItemParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ItemCreateItemParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ItemCreateItemParam} obj Optional instance to populate.
     * @return {module:model/ItemCreateItemParam} The populated <code>ItemCreateItemParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ItemCreateItemParam();

            if (data.hasOwnProperty('availableOrgIds')) {
                obj['availableOrgIds'] = ApiClient.convertToType(data['availableOrgIds'], ['Number']);
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('price')) {
                obj['price'] = ApiClient.convertToType(data['price'], 'Number');
            }
            if (data.hasOwnProperty('translation')) {
                obj['translation'] = ApiClient.convertToType(data['translation'], {'String': ItemItemTranslationParam});
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<Number>} availableOrgIds
 */
ItemCreateItemParam.prototype['availableOrgIds'] = undefined;

/**
 * @member {String} name
 */
ItemCreateItemParam.prototype['name'] = undefined;

/**
 * @member {Number} price
 */
ItemCreateItemParam.prototype['price'] = undefined;

/**
 * @member {Object.<String, module:model/ItemItemTranslationParam>} translation
 */
ItemCreateItemParam.prototype['translation'] = undefined;






export default ItemCreateItemParam;

